/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../../_chunks/dep-a26b9c60.mjs';
import { isVNode, computed, createVNode } from 'vue';
import { i as isBoolean_1 } from '../../_chunks/dep-11ebe61f.mjs';
import '../adapt.mjs';
import { getTNode } from '../util.mjs';
import useItemEvents from './useItemEvents.mjs';
import { usePrefixClass } from '../../hooks/useConfig.mjs';
import { Checkbox } from '../../checkbox/index.mjs';
import '../../_chunks/dep-b333ab93.mjs';
import '../../_chunks/dep-6f3e4f56.mjs';
import '../../_chunks/dep-b1060562.mjs';
import '../../_chunks/dep-8049d2e0.mjs';
import '../../utils/withInstall.mjs';
import '../../hooks/useVModel.mjs';
import '../../_chunks/dep-8747fcf0.mjs';
import '../../_chunks/dep-17446155.mjs';
import '../../_chunks/dep-7ad89920.mjs';
import '../../_chunks/dep-0d1bd08c.mjs';
import '../../_chunks/dep-c5d88cfe.mjs';
import '../../_chunks/dep-36563716.mjs';
import '../../hooks/useDefaultValue.mjs';
import 'tdesign-icons-vue-next';
import '../../loading/index.mjs';
import '../../loading/directive.mjs';
import '../../loading/plugin.mjs';
import '../../loading/loading.mjs';
import '../../_chunks/dep-89b33ff6.mjs';
import '../../_chunks/dep-6bcce672.mjs';
import '../../loading/icon/gradient.mjs';
import '../../_common/js/loading/circle-adapter.mjs';
import '../../_common/js/utils/set-style.mjs';
import '../../_common/js/utils/helper.mjs';
import '../../_chunks/dep-f7837681.mjs';
import '../../_chunks/dep-9c7a32ff.mjs';
import '../../_chunks/dep-5f6c8826.mjs';
import '../../_chunks/dep-c45cdd10.mjs';
import '../../_chunks/dep-ce88e3c0.mjs';
import '../../_chunks/dep-a432d90f.mjs';
import '../../config-provider/useConfig.mjs';
import '../../_chunks/dep-97c71289.mjs';
import '../../_chunks/dep-4efc69ee.mjs';
import '../../_chunks/dep-493c38ce.mjs';
import '../../_chunks/dep-b56b2dc0.mjs';
import '../../_chunks/dep-77f634fb.mjs';
import '../../_chunks/dep-28ae3cda.mjs';
import '../../_chunks/dep-e50fa7b0.mjs';
import '../../_chunks/dep-ae08d6c4.mjs';
import '../../_chunks/dep-7211604f.mjs';
import '../../_chunks/dep-75df64b1.mjs';
import '../../_chunks/dep-48b9a098.mjs';
import '../../_chunks/dep-c7e4942d.mjs';
import '../../_chunks/dep-25d66c95.mjs';
import '../../_chunks/dep-372265bb.mjs';
import '../../_chunks/dep-d940e2da.mjs';
import '../../_chunks/dep-52c1d6a9.mjs';
import '../../_chunks/dep-18bb982b.mjs';
import '../../_chunks/dep-c57d8117.mjs';
import '../../_chunks/dep-6043e9fc.mjs';
import '../../_chunks/dep-3a045465.mjs';
import '../../_chunks/dep-53dc0ac1.mjs';
import '../../_chunks/dep-b6b4eaa3.mjs';
import '../../_chunks/dep-881cffb7.mjs';
import '../../_chunks/dep-436b338d.mjs';
import '../../_common/js/global-config/default-config.mjs';
import '../../_common/js/global-config/locale/zh_CN.mjs';
import '../../_chunks/dep-2d31a683.mjs';
import '../../_chunks/dep-3ddc95d0.mjs';
import '../../config-provider/type.mjs';
import '../../utils/dom.mjs';
import '../../utils/easing.mjs';
import '../../utils/render-tnode.mjs';
import '../../_chunks/dep-ec227f3f.mjs';
import '../../_chunks/dep-0a6fd248.mjs';
import '../../_chunks/dep-b1013215.mjs';
import '../../_chunks/dep-91fc304f.mjs';
import '../../loading/props.mjs';
import '../../hooks/useTeleport.mjs';
import './style/css.mjs';
import '../../loading/type.mjs';
import '../../hooks/useGlobalIcon.mjs';
import '../../hooks/useLazyLoad.mjs';
import '../../_common/js/utils/observe.mjs';
import '../../hooks/useVirtualScrollNew.mjs';
import '../../hooks/useResizeObserver.mjs';
import '../../_common/js/tree/tree-node.mjs';
import '../../_chunks/dep-fc0ecd7a.mjs';
import '../../_chunks/dep-6d195cc7.mjs';
import '../../_chunks/dep-2311acd8.mjs';
import '../../_chunks/dep-87c358ba.mjs';
import '../../_chunks/dep-6e04bcaa.mjs';
import '../../_common/js/tree/tree-node-model.mjs';
import '../../_chunks/dep-7cc8d2c3.mjs';
import '../../_chunks/dep-d23f3733.mjs';
import '../../_chunks/dep-4b3e18ca.mjs';
import '../../_common/js/log/log.mjs';
import '../../_common/js/log/index.mjs';
import '../../checkbox/checkbox.mjs';
import '../../checkbox/props.mjs';
import '../../hooks/useRipple.mjs';
import '../../hooks/useKeepAnimation.mjs';
import '../../utils/set-style.mjs';
import '../../hooks/tnode.mjs';
import '../../checkbox/constants.mjs';
import '../../checkbox/hooks/useCheckboxLazyLoad.mjs';
import '../../checkbox/hooks/useKeyboardEvent.mjs';
import '../../_common/js/common.mjs';
import '../../hooks/useDisabled.mjs';
import '../../checkbox/group.mjs';
import '../../_chunks/dep-c0b45aa7.mjs';
import '../../_chunks/dep-8a9a248b.mjs';
import '../../checkbox/checkbox-group-props.mjs';
import '../../hooks/slot.mjs';
import '../../checkbox/type.mjs';

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _isSlot(s) {
  return typeof s === 'function' || Object.prototype.toString.call(s) === '[object Object]' && !isVNode(s);
}
function useRenderLabel(state) {
  var classPrefix = usePrefixClass().value;
  var componentName = usePrefixClass("tree").value;
  var _useItemEvents = useItemEvents(state),
    handleChange = _useItemEvents.handleChange;
  var renderLabel = function renderLabel(h) {
    var node = state.node,
      treeScope = state.treeScope;
    var scopedSlots = treeScope.scopedSlots,
      _treeScope$treeProps = treeScope.treeProps,
      treeProps = _treeScope$treeProps === void 0 ? {} : _treeScope$treeProps;
    var label = treeProps.label,
      expandOnClickNode = treeProps.expandOnClickNode;
    var checkProps = (treeProps === null || treeProps === void 0 ? void 0 : treeProps.checkProps) || {};
    var labelNode = null;
    if (label === true) {
      if (scopedSlots !== null && scopedSlots !== void 0 && scopedSlots.label) {
        labelNode = scopedSlots.label({
          node: node === null || node === void 0 ? void 0 : node.getModel()
        });
      } else {
        labelNode = node.label || "";
      }
    } else {
      labelNode = getTNode(label, {
        createElement: h,
        node: node
      });
    }
    var labelClasses = ["".concat(componentName, "__label"), _defineProperty({}, "".concat(classPrefix, "-is-active"), node.isActivable() ? node.actived : false)];
    var shouldStopLabelTrigger = computed(function () {
      var _node$children;
      var isNormalBranchNode = Array.isArray(node.children) && ((_node$children = node.children) === null || _node$children === void 0 ? void 0 : _node$children.length) > 0;
      var isLazyLoadChildBranchNode = isBoolean_1(node.children) && node.children;
      var isBranchNode = isNormalBranchNode || isLazyLoadChildBranchNode;
      return expandOnClickNode && isBranchNode;
    });
    if (node.vmCheckable) {
      var checkboxDisabled = false;
      if (node.vmIsLocked && !node.vmIsRest) {
        checkboxDisabled = true;
      }
      if (node.isDisabled()) {
        checkboxDisabled = true;
      }
      var itemCheckProps = _objectSpread(_objectSpread({}, checkProps), {}, {
        disabled: checkboxDisabled
      });
      var _labelNode = function () {
        return labelNode;
      }();
      labelNode = createVNode(Checkbox, {
        "class": labelClasses,
        "checked": node.checked,
        "indeterminate": node.indeterminate,
        "disabled": checkboxDisabled,
        "name": String(node.value),
        "onChange": handleChange,
        "stopLabelTrigger": shouldStopLabelTrigger.value,
        "ignore": "expand,active",
        "props": itemCheckProps
      }, _isSlot(labelNode) ? labelNode : {
        "default": function _default() {
          return [_labelNode];
        }
      });
    } else {
      var inner = createVNode("span", {
        "style": "position: relative"
      }, [labelNode]);
      labelNode = node.isActivable() ? createVNode("span", {
        "key": "1",
        "ref": "label",
        "class": labelClasses,
        "title": node.label
      }, [inner]) : createVNode("span", {
        "key": "2",
        "class": labelClasses,
        "title": node.label
      }, [inner]);
    }
    return labelNode;
  };
  return {
    renderLabel: renderLabel
  };
}

export { useRenderLabel as default };
//# sourceMappingURL=useRenderLabel.mjs.map
